import React, { useEffect, useState } from 'react';
import Header from '../../components/customer/Header';
import ProductGrid from '../../components/customer/ProductGrid';
import ImageCarousel from '../../components/customer/ImageCarousel';
import WhatsAppButton from '../../components/customer/WhatsAppButton';
import ModalAnuncio from '../../components/customer/ModalAnuncio';
import SEO from '../../components/common/SEO';
import { useProducts } from '../../hooks/useProducts';
import { apiService } from '../../services/api';
import styles from './Home.module.css';

const Home = () => {

  const { products } = useProducts({ limit: 8 });

  // Lazy initializer avoids an extra render cycle (showModal:false → read localStorage
  // → setShowModal(true) → re-render) which was triggering a forced reflow.
  const [showModal, setShowModal] = useState(
    () => !localStorage.getItem('anuncioMostrado')
  );

  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await apiService.getCategories();
        setCategories(data);
      } catch (error) {
        console.error('Error loading categories:', error);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    localStorage.setItem('anuncioMostrado', 'true');
  };

  const featuredProducts = products.filter(p => p.is_featured).slice(0, 3);
  const primeProducts = products.filter(p => p.is_prime).slice(0, 3);

  return (
    <div className={styles.home}>
      <SEO
        title="Nexa Global - Tienda Online de Productos de Calidad"
        description="Descubre nuestra amplia selección de productos electrónicos, ropa, hogar y más. Compra en línea con envío a toda Colombia."
      />
      <Header />

      <main className={styles.main}>
        {/* Banner carrusel con ofertas destacadas dentro */}
        <ImageCarousel images={["/Ropa.png", "/electronicos.jpg", "/hogar.jpg"]} featuredProducts={featuredProducts} />

        {/* Productos populares */}
        <section className={styles.section}>
          <h2>Productos Prime</h2>
          <ProductGrid products={primeProducts} />
        </section>

        {/* Categorías Dinámicas */}
        <section className={styles.section}>
          <h2>Categorías</h2>
          {loadingCategories ? (
            <p>Cargando categorías...</p>
          ) : (
            <div className={styles.categories}>
              {categories.map(category => (
                <a
                  key={category.id}
                  href={`/search?category_slug=${category.slug}`}
                  className={styles.categoryCard}
                >
                  {category.image_url ? (
                    <img
                      src={category.image_url}
                      alt={category.name}
                      width={400}
                      height={200}
                      loading="lazy"
                      decoding="async"
                    />
                  ) : (
                    <div className={styles.categoryPlaceholder}>
                      <span>📦</span>
                    </div>
                  )}
                  <h3>{category.name}</h3>
                </a>
              ))}
            </div>
          )}
        </section>
      </main>

      <footer className={styles.footer}>
        <p>&copy; 2025 NexaGlobal. Todos los derechos reservados.</p>
      </footer>

      <WhatsAppButton />
      {showModal && <ModalAnuncio onClose={handleCloseModal} />}
    </div>
  );
};

export default Home;